import React, { useEffect, useState } from "react";
import { Input } from "../input";
import BackModule from "./back.tsx";
import axios from "axios";
import { Toggle } from "../toggle.tsx";

// Icon resolver
// const skillIcon = (s: any) => {
//     const v = s.toLowerCase();
//     if (v.includes("petroleum")) return "⛽";
//     if (v.includes("public")) return "🏛️";
//     if (v.includes("litigation")) return "⚖️";
//     if (v.includes("family")) return "👪";
//     return "📘";
// };

export default function AgentsModule({ tab, setTab, baseUrl, currentUser, client }: { tab: string, setTab: (tab: string) => void, baseUrl: string, currentUser: any, client: any }) {
    const [search, setSearch] = useState("");
    const [view, setView] = useState("list");
    const [loading, setLoading] = useState(true);

    // Always arrays
    const [agents, setAgents] = useState([
        {
            uid: "AG001",
            name: "John Doe",
            skills: ["Petroleum", "Public"],
            skills_array: [{"id": "1", "picture": "path", "name": "Public"}],
            phone_code: "+47",
            company_no: "40862121",
            code: "1115",
            call_status: "busy",
            minutes: 74,
            revenue: 2000,
            is_active: true,
            receiving_calls_on: 'web',
        },
        {
            uid: "AG002",
            name: "Victoria Johnsen",
            skills: ["Litigation"],
            skills_array: [{"id": "2", "picture": "path", "name": "Litigation"}],
            phone_code: "+47",
            company_no: "634067007",
            code: "1138",
            call_status: "available",
            minutes: 33,
            revenue: 1000,
            is_active: true,
            receiving_calls_on: 'phone',
        },
        {
            uid: "AG003",
            name: "Jane Doe",
            skills: ["Family Law"],
            skills_array: [{"id": "3", "picture": "path", "name": "Family Law"}],
            phone_code: "+47",
            company_no: "45015507",
            code: "1142",
            call_status: "offline",
            minutes: 0,
            revenue: 500,
            is_active: false,
            receiving_calls_on: 'phone',
        },
    ]);

    const getAgents = async () => {
        try {
            const response = await axios.get(baseUrl + '/getAllAgents', { params: { token: currentUser?.token, client_uid: client?.uid } });

            if (response.data.status === "OK") {
                setAgents(response.data.data);
            }

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getAgents();
    }, [currentUser, client])

    const filtered = agents.filter((a) => {
        const q = search.toLowerCase();
        return (
            a?.name?.toLowerCase().includes(q) ||
            a?.uid?.toLowerCase().includes(q) ||
            a?.code?.toLowerCase().includes(q)
        );
    });

    const toggleActive = (idx: any) => {
        setAgents((prev) => {
            const copy = [...prev];
            copy[idx] = { ...copy[idx], receiving_calls_on: copy[idx].receiving_calls_on === "phone" ? 'web' : 'phone' };
            return copy;
        });
    };

    const updateStatus = (idx: any, value: any) => {
        setAgents((prev) => {
            const copy = [...prev];
            copy[idx] = { ...copy[idx], call_status: value };
            return copy;
        });
    };

    const editSkills = (idx: any) => {
        const current = agents[idx].skills.join("\n");
        const updatedList = window.prompt(
            "Egenskaper (en per linje):",
            current
        );
        if (updatedList === null) return;

        const arr = updatedList
            .split(/\n+/)
            .map((s) => s.trim())
            .filter(Boolean);

        setAgents((prev) => {
            const copy = [...prev];
            copy[idx] = { ...copy[idx], skills: arr };
            return copy;
        });
    };

    const showBackBtn = localStorage.getItem("previousPage") ? true : false;

    const handleNavigation = (to: string) => {
        localStorage.setItem("previousPage", "Agenter");
        setTab(to);
    }

    return (
        <div className="min-h-screen bg-slate-50 p-8">
            {showBackBtn && (
                <BackModule setTab={setTab} label={localStorage.getItem("previousPage") || ""} />
            )}
            <h1 className="text-2xl font-semibold mb-6">Agenter</h1>

            {/* SEARCH + ACTIONS */}
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-6">
                <Input
                    type="text"
                    placeholder="Søk etter agent, UID eller ext..."
                    value={search}
                    onChange={(e: any) => setSearch(e.target.value)}
                    className="px-4 py-2 w-full md:w-72 rounded-xl border border-slate-300 text-sm"
                />

                <div className="flex items-center gap-3">
                    <div className="inline-flex rounded-xl border border-slate-200 bg-white overflow-hidden">
                        <button
                            title="Gridvisning"
                            onClick={() => setView("grid")}
                            className={`px-3 py-2 text-sm ${view === "grid"
                                ? "bg-slate-900 text-white"
                                : "text-slate-600 hover:bg-slate-50"
                                }`}
                        >
                            🔳
                        </button>

                        <button
                            title="Listevisning"
                            onClick={() => setView("list")}
                            className={`px-3 py-2 text-sm border-l border-slate-200 ${view === "list"
                                ? "bg-slate-900 text-white"
                                : "text-slate-600 hover:bg-slate-50"
                                }`}
                        >
                            📄
                        </button>
                    </div>

                    <button onClick={() => handleNavigation("Agent detail")} className="px-4 py-2 rounded-xl bg-slate-900 text-white text-sm">
                        + Ny agent
                    </button>

                    <button className="px-4 py-2 rounded-xl bg-indigo-50 text-indigo-700 border border-indigo-200 text-sm">
                        Importer CSV
                    </button>
                </div>
            </div>

            {loading ? (
                <div className="flex items-center justify-center h-64">
                    <div className="flex flex-col items-center">
                        <div className="w-12 h-12 border-4 border-purple-400 border-t-transparent rounded-full animate-spin"></div>
                        <p className="mt-3 text-gray-600 animate-pulse">Laster...</p>
                    </div>
                </div>
            ) : (
                <>
                    {/* GRID VIEW */}
                    {view === "grid" && (
                        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
                            {filtered.map((agent, idx) => (
                                <div
                                    key={agent.uid}
                                    className="bg-white rounded-2xl border border-slate-200 p-5 shadow-sm hover:shadow-md transition flex flex-col gap-3"
                                >
                                    <div className="flex items-start justify-between">
                                        <div>
                                            <h2 className="font-semibold text-slate-900 text-lg">{agent.name}</h2>
                                            <p className="text-xs text-slate-500 mt-0.5">
                                                UID: {agent.uid} · Ext: {agent.code}
                                            </p>
                                        </div>
                                        <span
                                            className={`px-2 py-1 text-xs rounded-full font-medium capitalize ${agent.call_status === "busy"
                                                ? "bg-red-50 text-red-600"
                                                : agent.call_status === "available"
                                                    ? "bg-emerald-50 text-emerald-700"
                                                    : "bg-slate-100 text-slate-500"
                                                }`}
                                        >
                                            {agent.call_status === "available"
                                                ? "Ledig"
                                                : agent.call_status === "busy"
                                                    ? "I samtale"
                                                    : "Avlogget"}
                                        </span>
                                    </div>

                                    {/* Skills */}
                                    <button
                                        onClick={() => editSkills(idx)}
                                        className="flex items-center gap-2 text-xs text-slate-500 hover:text-slate-700 group w-fit"
                                    >
                                        <span className="font-medium text-slate-700">Ferdigheter:</span>
                                        <span className="flex gap-1">
                                            {agent.skills_array.map((s, i) => (
                                                <span
                                                    key={i}
                                                    title={s.name}
                                                    className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-slate-100 text-base group-hover:bg-slate-200"
                                                >
                                                    <img src={s.picture} alt={s.name} className="w-full h-full object-cover" />
                                                </span>
                                            ))}
                                        </span>
                                        <span className="underline decoration-dotted">Rediger</span>
                                    </button>

                                    <div className="grid grid-cols-2 gap-y-1 text-sm text-slate-600">
                                        <span className="text-slate-500">Telefon</span>
                                        <span>
                                            {agent.phone_code} {agent.company_no}
                                        </span>
                                        <span className="text-slate-500">Minutter i dag</span>
                                        <span>{agent.minutes}</span>
                                        <span className="text-slate-500">Omsetning</span>
                                        <span>{agent.revenue}</span>
                                    </div>

                                    <div className="flex items-center justify-between gap-3 pt-3 border-t border-slate-100 mt-auto">
                                        {/* LOGIN TOGGLE */}
                                        <label className="inline-flex items-center cursor-pointer gap-2">
                                            <Toggle label={""} checked={agent.receiving_calls_on === "phone" ? false : true} onChange={() => toggleActive(idx)} bordering={false} insideLabel={"ReceivingCallSwitch"} />
                                        </label>

                                        {/* STATUS */}
                                        <select
                                            value={agent.call_status}
                                            onChange={(e) => updateStatus(idx, e.target.value)}
                                            className="px-2 py-1 text-xs rounded-lg border border-slate-300 bg-white text-slate-700"
                                        >
                                            <option value="available">🟢 Ledig</option>
                                            <option value="busy">🔴 I samtale</option>
                                            <option value="offline">⚪ Avlogget</option>
                                        </select>

                                        <button className="text-indigo-500 text-lg">💬</button>
                                        <button className="text-emerald-600 text-lg">📞</button>
                                        <button onClick={() => handleNavigation("Agent detail")} className="text-slate-500 text-lg">✏️</button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* LIST VIEW */}
                    {view === "list" && (
                        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-4 overflow-x-auto">
                            <table className="w-full text-sm">
                                <thead>
                                    <tr className="bg-slate-100 text-left text-slate-600 text-xs">
                                        <th className="p-2">Agent</th>
                                        <th className="p-2">Ferdigheter</th>
                                        <th className="p-2">Status</th>
                                        <th className="p-2">Telefon</th>
                                        <th className="p-2">Mottar på</th>
                                        <th className="p-2">Handlinger</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filtered.map((agent, idx) => (
                                        <tr key={agent.uid} className="border-b border-slate-200 hover:bg-slate-50">
                                            <td className="p-2 font-medium text-slate-800">
                                                {agent.name}
                                                <br />
                                                <span className="text-xs text-slate-500">Ext: {agent.code}</span>
                                            </td>

                                            <td className="p-2">
                                                {agent.skills_array.map((s, i) => (
                                                    <span
                                                        key={i}
                                                        title={s.name}
                                                        onClick={() => editSkills(idx)}
                                                        className="inline-flex items-center justify-center w-6 h-6 mr-1 rounded-full bg-slate-100 hover:bg-slate-200 cursor-pointer"
                                                    >
                                                        <img src={s.picture} alt={s.name} className="w-full h-full object-cover" />
                                                    </span>
                                                ))}
                                            </td>

                                            <td className="p-2">
                                                <select
                                                    value={agent.call_status}
                                                    onChange={(e) => updateStatus(idx, e.target.value)}
                                                    className="px-2 py-1 text-xs rounded-lg border border-slate-300 bg-white text-slate-700"
                                                >
                                                    <option value="available">🟢 Ledig</option>
                                                    <option value="busy">🔴 I samtale</option>
                                                    <option value="offline">⚪ Avlogget</option>
                                                </select>
                                            </td>

                                            <td className="p-2">
                                                {agent.phone_code} {agent.company_no}
                                            </td>

                                            <td className="p-2">
                                                <Toggle label={""} checked={agent.receiving_calls_on === "phone" ? false : true} onChange={() => toggleActive(idx)} bordering={false} insideLabel={"ReceivingCallSwitch"} />
                                            </td>

                                            <td className="p-2 flex gap-3 text-lg">
                                                <button onClick={() => handleNavigation("Agent detail")} className="text-slate-500 hover:text-slate-800">✏️</button>
                                                <button className="text-indigo-500 hover:text-indigo-700">💬</button>
                                                <button className="text-emerald-600 hover:text-emerald-800">📞</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
